// components/members/VicePresidentDetailPage.js
import React, { useState } from 'react';
import { Button, Modal, Image } from 'react-bootstrap';
import { Files } from 'react-bootstrap-icons';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../App.css';
import './VicePresidentDetailPage.css';

const formatDate = (inputDate) => {
  if (!inputDate) return '';
  const date = new Date(inputDate);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${month}-${day}-${year}`;
};

function VicePresidentDetailPage() {
  const { t } = useTranslation('common');
  const location = useLocation();

  const name = location.state?.name;
  const termStart = location.state?.termStart;
  const termEnd = location.state?.termEnd;
  const imageSource = location.state?.imageSource;
  const description = location.state?.description || '';

  const [showBioModal, setShowBioModal] = useState(false);

  const truncateDescription = (desc, maxLength) => {
    if (!desc) return '';
    if (desc.length > maxLength) {
      return desc.substring(0, maxLength) + '...';
    }
    return desc;
  };

  const truncatedDescription = truncateDescription(description, 200);

  const renderEndTerm = () => {
    const formattedEndTerm = formatDate(termEnd);
    if (formattedEndTerm === '12-31-1969' || !termEnd) {
      return t('common:present', 'Present');
    }
    return formattedEndTerm;
  };

  return (
    <div id='feedDisplay' className="vp-detail-page">
      {/* Vice President Header */}
      <div className="vp-header">
        {imageSource && (
          <div className="vp-profile-image">
            <Image id='profileImage-image' src={imageSource} alt="" />
          </div>
        )}

        <div className="vp-profile-info">
          <div className="vp-name">
            <span>{name}</span>
          </div>
          <div className="vp-title">
            <span>{t('common:usVicePresident', 'U.S. Vice President')}</span>
          </div>
          {termStart && (
            <div className="vp-term">
              <span>{t('common:termRange', 'From {{start}} To {{end}}', { start: formatDate(termStart), end: renderEndTerm() })}</span>
            </div>
          )}
        </div>
      </div>

      {/* Profile save/share buttons were commented out here. To bring them back,
          use the useCollections hook and its CollectionButton the way
          PresidentDetailPage now does - not the module-level stored* globals. */}

      {/* Biography */}
      {description && (
        <div className="vp-section">
          <div className="vp-biography" dangerouslySetInnerHTML={{ __html: truncatedDescription }} />
          <Button id='repsViewMore' onClick={() => setShowBioModal(true)}>
            <Files size={20} /> {t('common:readMore', 'Read More')}
          </Button>
        </div>
      )}

      {/* Coming Soon Placeholder */}
      <div className="vp-section">
        <div className="vp-section-heading">
          {t('common:documentsAndHistory', 'Documents & History')}
        </div>
        <p className="vp-placeholder">{t('common:comingSoon', 'Coming Soon')}</p>
      </div>

      <div className="vp-page-tail" />

      {/* Bio Modal */}
      <Modal id='fullBillModal' size="xl" show={showBioModal} onHide={() => setShowBioModal(false)}>
        <Modal.Header id='billModalHeader' closeButton>
          <h3>{t('common:biographyTitle', "{{name}}'s Biography", { name })}</h3>
        </Modal.Header>
        <div id='fullBillFeed'>
          <div className="vp-modal-content" dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      </Modal>
    </div>
  );
}

export default VicePresidentDetailPage;